import { locales } from './locales.util';

export const formatNumber = (number: number, maximumSignificantDigits = 2) =>
  new Intl.NumberFormat(locales['fr-FR'], {
    maximumSignificantDigits,
  }).format(number);
